export default {
  title: 'Login',

  getPhoneNumberStepMessage1: 'Please enter your phone number. SMS password ',
  getPhoneNumberStepMessage2: '(five-digit code)',
  getPhoneNumberStepMessage3: 'will be sent to confirm your number.',
  phoneNumber: 'Phone Number',
  phoneNumberIsNotValid: 'Phone number not entered correctly',
  phoneNumberIsNull: 'Phone number not entered',

  otpCodeSentStepMessage1: 'For ',
  otpCodeSentStepMessage2: 'A 5-digit code was sent. Please enter the code ',
  otpCodeIsNotValid: 'The validation code was not entered correctly',
  otpCodeIsNull: 'Authentication code not entered',
  retrieveTheCode: 'retrieve code',

  loginToPanel: 'Login to panel {name}',
  resendOTPMessage: 'Choose one of the following methods to retrieve the code',
  otpCall: '{number} will be called in a few moments',
  selectCompany: 'Please choose your company',
  search: 'Search companies',
  searchBtn: 'Search',
  resendOTPTypes: {
    resend: 'Resend',
    sms: 'SMS',
    mail: 'mail',
    whatsapp: 'whatsApp',
    tel: 'Contact'
  },

  otpSendToTypes: {
    mail: 'mail',
    sms: 'phone number',
    whatsapp: 'whatsApp'
  },

  otp: 'One Time password',
  otpSend: 'One Time password sent to {number}',

  getSuperAdminTokenStepMessage: 'Please enter your token.',
  token: 'system administrator token',

  buttons: {
    getOTPCode: 'Get Code',
    login: 'Login'
  },

  notification: {
    userNotFound: 'User not found with this phone number!',
    tryAfter2Minutes: 'Please try after 2 minutes',
    sendOtpFailed: 'Send otp failed',
    otpInvalid: 'OTP is not valid',
    otpExpired: 'OTP expired',
    accessError: 'Access denied to system!',

    login: {
      title: 'Message',
      message: 'You have successfully logged in'
    },

    logout: {
      title: 'Message',
      message: 'You have successfully logged out'
    },

    forceLogout: {
      title: 'Message',
      message: 'Please log in again due to not using the system for a long time'
    }
  }

}
